export default (props, traits) => {
  return {
    image: {
      width: '100%'
    }
  }
}
